import React, { useEffect, useState } from 'react'
import Button from '../../component/Button'
import classes from "./style.module.scss";
import UserRetailRequest from './components/UserRetailRequest';
import GenerateSlot from '../../modalComponents/GenerateSlot';
import UserDetails from './components/UserDetails';
import { useLocation } from 'react-router-dom';
import SearchBox from '../../component/SearchBox';

const UsersComponent = () => {
  const NEW_RETAIL = 'New Retailers request'
  const VERIFIED_RETAIL = 'Verified Retailers'
  const ALL_USERS = 'All Users'
  const INCOMPLETE_RETAIL = 'Incomplete Retailer'
  const INCOMPLETE_MECHANIC = 'Incomplete Mechanic'
  const REJECTED_RETAILER = 'Rejected Retailer'
  const COMPLETE_MECHANIC = 'Completed Mechanic'
  const RETAILERS_WITHOUT_TARGET = 'Retailers Without Target'

  const USERLIST = [NEW_RETAIL, VERIFIED_RETAIL, ALL_USERS, INCOMPLETE_RETAIL, INCOMPLETE_MECHANIC, REJECTED_RETAILER, COMPLETE_MECHANIC, RETAILERS_WITHOUT_TARGET];
  const [searchInput, setSearchInput] = useState('')
  const [activeTab, setActiveTab] = useState(NEW_RETAIL)
  const [showPopUp, setShowPopUp] = useState(false)
  const [viewData, setViewData] = useState(null)
  const [userInfo, setUserInfo] = useState(false)
  const location = useLocation();

  useEffect(() => {
    setSearchInput('')
    setViewData(null)
  }, [activeTab])

  useEffect(() => {
    if (location?.pathname) {
      const params = getUserId()
      if (params) {
        setUserInfo(true)
      } else {
        setUserInfo(false)
      }
    }
  }, [location])

  const getUserId = () => {
    const pathName = location?.search?.split('?id=')
      const params = pathName[pathName?.length - 1]
      return params
  }

  const handleChange = (value) => {
    setSearchInput(value)
  }

  const getActiveTab = () => {
    let userRole = {};
    if (activeTab === NEW_RETAIL) {
      userRole['role'] = 2
      userRole['type'] = 'new_user'
    } else if (activeTab === VERIFIED_RETAIL) {
      userRole['role'] = 2
      userRole['type'] = 'verfied_retailers'
    } else if(activeTab == INCOMPLETE_RETAIL) {
      userRole['role'] = 2
      userRole['isApprovedByFilter'] = 2
    } else if(activeTab == INCOMPLETE_MECHANIC) {
      userRole['role'] = 3
      userRole['isApprovedByFilter'] = 2
    } else if(activeTab == REJECTED_RETAILER) {
      userRole['role'] = 2
      userRole['type'] = 'rejected_retailers'
    } else if(activeTab == COMPLETE_MECHANIC) {
      userRole['role'] = 3
      userRole['type'] = 'completed_mechanics'
    } else if(activeTab == RETAILERS_WITHOUT_TARGET) {
      userRole['role'] = 2
      userRole['type'] = 'retailers_without_target'
    } else {
      userRole['role'] = null
      userRole['type'] = null
    }
    return userRole
  }

  return (
    <>
      {userInfo ?
        <UserDetails viewData={viewData} userId={getUserId()} currentTab={activeTab} />
        :
        <div className={`${classes.manageUserWrapper}`}>
          <div className={`w-[100%] flex items-center justify-between`}>
            <div className={`layout-title`}>Manage Users</div>
            <div className='flex items-center'>
              <SearchBox className={''} value={searchInput} onChange={handleChange} placeholder={'Find by name, type, mobile...'} />
              {/* <Button text={"Generate Slots"} className={`ml-5`} smallBtn onClick={() => setShowPopUp(true)} /> */}
            </div>
          </div>
          <div className={`${classes.userHeaderList} w-[100%] flex items-center cursor-pointer`}>
            {USERLIST?.map((title) => <div className={`${classes.userTab} ${activeTab === title ? classes.activeTab : ''}`} onClick={() => setActiveTab(title)}>{title}</div>)}
          </div>
          <div>
            <UserRetailRequest activeTab={getActiveTab()} searchInput={searchInput} setViewData={setViewData} />
          </div>
        </div>
      }
      {showPopUp ?
        <GenerateSlot isOpen={showPopUp} closePopUp={setShowPopUp} />
        : null
      }
    </>
  )
}

export default UsersComponent